<template>
  <div class="lesson-in-config-wrapper">
    <!-- 加载&没有数据状态 -->
    <div v-if="!list || !list.coursewareFragments.length" class="lesson-in-config-empty">
      <a-spin v-if="loading" class="loading" tip="内容加载中..." size="large" />
      <Empty v-else :content="暂无内容" />
    </div>
    <!-- 配置&预览 -->
    <div v-if="list && list.coursewareFragments.length" class="lesson-in-config">
      <div class="lesson-in-config-operate" :class="[!layOutNormal && 'lesson-in-config-operate-columns']">
        <div class="title lesson-title">
          <span>配置区</span>
          <!-- <span v-if="lockDisabled && layOutNormal" class="tip">
            <a-icon class="tip-icon" type="exclamation-circle" />
            本讲次已解锁，不可更改配置
          </span> -->
          <a-button
            v-gdd-hide
            v-if="layOutNormal"
            @click="onRefresh"
            type="link"
            icon="sync"
            :disabled="disabledPull"
          >
            重新拉取
          </a-button>
        </div>
        <Duration
          :duration="duration"
          :lay-out-normal="layOutNormal"
          @setNotStudy="setNotStudy"
          :show-not-study-ctr="showNotStudyCtr"
          :check-not-study="checkNotStudy"
          :edit-enable="editEnable"
        />
        <FragList
          :is-show-less-column="isShowLessColumn"
          :courseware-fragments="list.coursewareFragments"
          @updateList="updateList"
          :edit-enable="editEnable"
          @play="play"
          :current-play="currentPlay"
          :is-show="isShow"
        />
      </div>
      <div class="lesson-in-config-preview" :class="[layOutNormal ? 'lesson-in-config-preview-nomal-w' : 'lesson-in-config-preview-large-w']">
        <!-- 视频播放区域 -->
        <div class="title">
          <span class="fragment-name">
            预览区
            <span class="name">{{ getName() }}</span>
          </span>
          <a-button ghost type="primary" @click="toggleLayout" class="layout-btn">
            <SvgIcon :icon="!layOutNormal ? 'beike-nomal' : 'beike-enlarged'" class="layout-icon" />
            {{ layOutNormal ? "放大" : "还原" }}
          </a-button>
        </div>
        <div class="player-wrap">
          <div :class="[layOutNormal ? 'player' : 'player-large-screen']" ref="playerWrap">
            <div id="videoScaleEle" ref="videoScaleEle" />
          </div>
          <!-- 预览区 -->
          <div v-gdd-hide class="lesson-in-config-preview-list">
            <fragPreview
              type="before"
              :list="duration.beforeList"
              title="课前学"
              tip="学生可在学习机或家长端上学习课前学部分"
              @play="play"
              @preview="preview"
              :current-play="currentPlay"
            />
            <fragPreview
              type="middle"
              :list="duration.middleList"
              title="课中学"
              tip="学习机的回放内容为课中学的所有片段"
              @play="play"
              @preview="preview"
              :current-play="currentPlay"
            />
            <fragPreview
              type="after"
              :list="duration.afterList"
              title="课后学"
              tip="学生可在学习机或家长端上学习课后学部分"
              @play="play"
              @preview="preview"
              :current-play="currentPlay"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 按钮 -->
    <div v-if="list && list.coursewareFragments.length" class="lesson-in-config-button">
      <div class="learn-home-check">
        <!-- :disabled="saveEnable" -->
        <div v-gdd-hide>
          <a-checkbox @change.stop="learnAtHome" :checked="learnAtHomeChecked">
            <span class="learn-at-home">
              <span class="text text-default">本讲在家学</span>
            </span>
          </a-checkbox>
          <a-tooltip placement="top">
            <template slot="title">
              <p class="check-tip" style="width: 268px; letter-spacing: 0.04em">
                <span>勾选上“本讲在家学”后，学生可通过</span>
                <strong>小括狐家长端小程序</strong>
                <span>进行本讲的学习和闯关</span>
              </p>
            </template>
            <a-icon type="info-circle" class="tip-icon" />
          </a-tooltip>
        </div>
      </div>
      <span class="btns">
        <a-button style="margin-right: 10px" @click="cancel">取消</a-button>
        <!-- :disabled="!saveEnable" -->
        <a-button type="primary" @click="savePrepareLesson"> 确定{{ userInfo.gddHide ? "" : "并保存" }} </a-button>
      </span>
    </div>
  </div>
</template>
<script>
import { createApp } from 'vue-demi'
import Empty from './components/com-empty.vue'
import Duration from './components/duration.vue'
import FragList from './components/fragList.vue'
import AliVideoScale from '@/components/VideoPlayer/videoScale.vue'
import VideoScale from '@/components/PolyvPlayer/VideoScale.vue'
import fragPreview from './components/fragPreview.vue'
import service from '@/service/correction'
import { TYPE as TABTYPE } from '../constants'
import { formatDuration } from '@/utils/index'
import correctLogger from '@/utils/logger/correct.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    Duration,
    FragList,
    fragPreview,
    Empty
  },
  props: {
    lessonInfo: {
      type: Object,
      default: () => {}
    },
    tabType: {
      type: Number,
      default: () => TABTYPE.CONFIG
    },
    isShow: Boolean
  },
  data() {
    return {
      learnAtHomeChecked: false,
      checkNotStudy: false,
      layOutNormal: true,
      isShowLessColumn: false,
      loading: true,
      list: undefined,
      saveEnable: true,
      // 讲次是否锁定
      // lockDisabled: false,
      editEnable: false,
      videoFinish: false,
      currentPlay: {
        type: 1,
        index: undefined,
        courseType: -1
      },
      videoPlayer: null
    }
  },
  mounted() {
    this.getList().then(this.mountVideoPlayer)
    window.onresize = this.setVideoSize
  },
  destroyed() {
    window.onresize = null
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo/userInfo'
    }),
    showNotStudyCtr() {
      const bool = this.list?.coursewareFragments.find(k => k.noStudy)
      return bool
    },
    duration() {
      if (this.list.length < 1) {
        return {
          total: '00:00:00',
          before: '00:00:00',
          beforeList: [],
          middle: '00:00:00',
          middleList: [],
          after: '00:00:00',
          afterList: []
        }
      }

      const updateValue = () => {
        let total = 0
        let before = 0
        const beforeList = []
        let middle = 0
        const middleList = []
        let after = 0
        const afterList = []

        this.list?.coursewareFragments.forEach(item => {
          let { duration, durationInteraction } = item
          const durationInteractionVal = durationInteraction || 0
          duration = Math.floor(duration + durationInteractionVal)
          if (item.before) {
            before += duration
            beforeList.push(item)
          }
          if (item.among) {
            middle += duration
            middleList.push(item)
          }
          if (item.after) {
            after += duration
            afterList.push(item)
          }
        })
        total = formatDuration(before + middle + after)
        before = formatDuration(before)
        middle = formatDuration(middle)
        after = formatDuration(after)
        return { before, beforeList, middle, middleList, after, afterList, total }
      }

      return updateValue()
    },

    disabledPull() {
      const { beforeClassState, lockStatus } = this.lessonInfo
      // 课前解锁或讲次解锁都禁用重新拉取片段
      const bool = beforeClassState === 1 || lockStatus === 2
      return bool
    }
  },
  watch: {
    tabType(newVal) {
      if (newVal !== TABTYPE.CONFIG) {
        this.videoFinish && this.videoPlayer.pause()
      }
    }
  },
  methods: {
    learnAtHome(e) {
      this.learnAtHomeChecked = e.target.checked
    },
    setNotStudy(bool) {
      if (bool) {
        // 所有选学设置为不学
        this.list.coursewareFragments.forEach(k => {
          if (k.noStudy && !k.study) {
            k.study = true
            k.before = k.among = k.after = false
          }
        })
      } else {
        // 取消开关-所有选学设置为学
        this.list.coursewareFragments.forEach(k => {
          if (k.noStudy && k.study) {
            k.study = false
            // 关闭不学时，默认选中课中学
            k.among = true
          }
        })
      }
    },
    setVideoSize() {
      if (!this.$refs.playerWrap) return
      this.$nextTick(() => {
        const { offsetWidth, offsetHeight } = this.$refs.playerWrap
        this.$refs.videoScaleEle.width = offsetWidth
        this.$refs.videoScaleEle.height = offsetHeight
      })
    },
    toggleLayout() {
      this.layOutNormal = !this.layOutNormal
      this.isShowLessColumn = !this.isShowLessColumn
      // 设置视频宽度
      this.$nextTick(() => {
        this.setVideoSize()
      })
    },
    async getList(refreshVerison) {
      const { id, classTypeId, lessonId, aiLessonId, xkhTeacherCourseId: groupId } = this.lessonInfo
      // 1.获取课程配置信息
      const list = await service.getPrepareInfo({ id, classTypeId, lessonId, aiLessonId, groupId, refreshVerison })
      const isPolyv = list.playerType === 1
      list.coursewareFragments = isPolyv ? list.coursewareFragments : list.videoPartScriptJs
      list.scriptJson = isPolyv ? list.scriptJson : list.videoFragmentList
      this.list = list.coursewareFragments ? list : { coursewareFragments: [] }
      this.loading = false
      this.learnAtHomeChecked = !!list.studyHome
      if (list.coursewareFragments) {
        // this.saveEnable = list.lockStatus === 1 && list.beforeClassState !== 1
        // this.lockDisabled = !this.saveEnable
        if (list.coursewareFragments.length === 1) {
          list.coursewareFragments[0].index = 0
          // 只有一个片段时，不可对片段做配置，可以修改是否在家学
          this.saveEnable = false
        }
        // this.editEnable = this.saveEnable && list.coursewareFragments.length > 1
        this.editEnable = list.coursewareFragments.length > 1 // 解锁后，还能再做修改

        // 默认选中第一个片段
        this.currentPlay.type = 1
        this.currentPlay.index = 0
        return list
      }
    },
    // 初始化播放，默认选中片段播放
    initPlay() {
      console.log('initPlay', this.list, this.videoFinish, this.currentPlay)
      const { videoFinish, currentPlay, list } = this
      if (videoFinish && list && list.coursewareFragments.length) {
        this.videoPlayer.voChangeTags([list.coursewareFragments[currentPlay.index]])
      }
    },
    mountVideoPlayer(list) {
      if (!list) return
      this.videoFinish = false
      if (!list.coursewareFragments.length) {
        return
      }
      const isPolyv = list.playerType === 1
      // { width: this.videoW, height: this.videoH }
      const videoPlayer = createApp(isPolyv ? VideoScale : AliVideoScale).mount(this.$refs.videoScaleEle)
      videoPlayer.$on('tagChange', this.tagChange)
      this.$refs.videoScaleEle = videoPlayer
      const { coursewareFragments, scriptJson, path } = list

      // 初始化播放器
      this.$nextTick(() => {
        videoPlayer.$el.classList.add('player')
        this.setVideoSize()
        if (isPolyv) {
          videoPlayer.playerInit({ scriptJson, videoUrl: path }).then(() => {
            // 初始化成功
            this.videoFinish = true
            this.initPlay()
          })
        } else {
          videoPlayer.playerInit({
            fragmentList: scriptJson,
            videoList: coursewareFragments
          })
          this.videoFinish = true
        }
      })
      this.videoPlayer = videoPlayer
    },
    async savePrepareLesson() {
      const item = this.list.coursewareFragments.find(item => item.among === true)
      if (!item) {
        this.$message.error('保存失败，至少要选择一段为课中学')
        return
      }
      this.$confirm({
        title: '',
        content: h => '您确认保存所有环节配置吗？',
        onOk: () =>
          new Promise((resolve, reject) => {
            if (this.list.coursewareFragments.length === 1) {
              this.list.coursewareFragments[0].index = -1
            }
            service
              .savePrepareInfo({
                id: this.lessonInfo.id,
                coursewareFragments: this.list.coursewareFragments.map(item => {
                  delete item.durationInteraction
                  return {
                    ...item
                  }
                }),
                coursewareVersion: this.list.coursewareVersion,
                studyHome: this.learnAtHomeChecked ? 1 : 0 // 是否在家学(0:否，1:是)
              })
              .then(res => {
                resolve()
                this.$message.success('保存成功')
                this.$emit('handleCancel')
              })
              .catch(err => {
                reject(err)
              })
            const { lessonId, aiLessonId, classTypeId, groupId } = this.lessonInfo
            correctLogger.confCourse({
              lessonId,
              aiLessonId,
              courseId: classTypeId,
              groupId
            })
          }),
        onCancel() {
          console.log('Cancel')
        }
      })
    },
    updateList(index, key, value) {
      const item = this.list.coursewareFragments.find(item => item.index === index)
      item[key] = value
      if (key === 'study') {
        if (value) {
          item.before = item.among = item.after = false
        } else {
          // 关闭不学时，默认选中课中学
          item.among = true
        }
        // 选学片段都设为不学时，设置勾选全部
        const notStudyLength = this.list.coursewareFragments.filter(k => k.noStudy)
        const notStudyCheckedLength = this.list.coursewareFragments.filter(k => k.noStudy && k.study)
        console.log('notStudyLength, notStudyCheckedLength', notStudyLength, notStudyCheckedLength)
        this.checkNotStudy = notStudyLength.length === notStudyCheckedLength.length
      } else {
        if (!value && !item.before && !item.among && !item.after) {
          // 如果都不选，需要打开不学
          item.study = true
        }
      }
    },
    cancel() {
      this.$emit('handleCancel')
    },
    play(record, type = 1, courseType) {
      if (!this.videoFinish) {
        this.$message.error('视频加载中，请重试')
        return
      }
      console.log('record, type, courseType', record, type, courseType)
      this.currentPlay.type = type
      this.currentPlay.courseType = courseType
      this.currentPlay.index = record.index
      this.videoPlayer.voChangeTags([record])
    },
    preview(courseType, playType) {
      if (!this.videoFinish) {
        this.$message.error('视频加载中，请重试')
        return
      }
      this.currentPlay.type = playType
      const list = this.duration[courseType + 'List']
      this.videoPlayer.voChangeTags(list)
    },
    tagChange({ index }) {
      this.currentPlay.index = index
    },
    getName() {
      const {
        currentPlay: { index },
        list: { coursewareFragments }
      } = this
      return index === undefined ? '' : coursewareFragments[index === -1 ? 0 : index].name
    },
    onRefresh() {
      this.$confirm({
        title: '确定获取最新片段吗？',
        content: h => (
          <div>
            <div>
              <span class="circle">&bull;</span>确定后，列表将展示最新的课程片段。
            </div>
            <div>
              <span class="circle">&bull;</span>所有片段配置将默认勾选为“课中学”。
            </div>
          </div>
        ),
        bodyStyle: {
          justifyContent: 'flex-start',
          paddingTop: '30px'
        },
        onOk: () =>
          new Promise((resolve, reject) => {
            // 展示loading窗
            this.loading = true
            // 销毁播放器
            this.videoPlayer.$destroy()
            const { $el: el } = this.videoPlayer
            el.innerHTML = null
            this.$refs.videoScaleEle = el
            this.videoFinish = false
            // 触发数据刷新
            this.getList(true)
              .then(this.mountVideoPlayer)
              .then(() => {
                resolve()
              })
              .catch(reject)
          }),
        onCancel() {
          console.log('Cancel')
        },
        class: 'course-group-page-test'
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "~@/static/css/base.less";

// 按钮
.lesson-in-config-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  .lesson-in-config-empty {
    display: flex;
    align-items: center;
    height: 100%;
  }
  .loading {
    width: 100%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
  .lesson-in-config-button {
    height: 64px;
    border-top: 1px solid #ebedf0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    .learn-home-check {
      padding-left: 24px;
      flex: 1 1 0;
      .learn-at-home {
        .text {
          font-family: "Microsoft YaHei UI";
          font-style: normal;
          font-weight: 400;
          font-size: 14px;
          letter-spacing: 0.04em;
        }
        .text-default {
          color: #ff8800;
        }
        // .text-disabled {
        //   color: #98A2B2;
        // }
      }
      .tip-icon {
        margin-left: -2px;
        cursor: pointer;
        color: #98a2b2;
      }
    }
    .btns {
      flex: 1 1 auto;
      margin-right: 138px;
    }
  }
  .player {
    height: calc(100% - 170px);
  }
  .player-large-screen {
    height: calc(100% - 70px);
  }
}
// 内容区
.lesson-in-config {
  height: calc(100% - 64px);
  width: 100%;
  display: flex;
  &-operate {
    flex: 1;
    width: 200px;
    padding: 20px;
    border-right: 1px solid #ebedf0;
  }
  &-operate-columns {
    flex: 1;
    width: 0;
    padding: 20px;
    border-right: 1px solid #ebedf0;
  }
  &-preview {
    box-sizing: border-box;
    padding: 20px 0 0 20px;
  }
  &-preview-nomal-w {
    flex: 1;
    width: calc(100% - 520px);
  }
  &-preview-large-w {
    width: calc(100% - 195px);
  }
  .title {
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    color: #505873;
    padding-bottom: 12px;
    display: flex;
    align-items: center;
    position: relative;
    .fragment-name {
      .name {
        display: inline-block;
        padding-left: 16px;
        font-weight: 400;
        font-size: 14px;
      }
    }
    > .tip {
      padding: 4px 16px 4px 16px;
      background: #fff8e5;
      border-radius: 6px;
      cursor: default;
      position: absolute;
      left: 64px;

      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
      color: #505873;
      > .tip-icon {
        color: #ff8800;
        position: relative;
        top: 1px;
        padding-right: 1px;
      }
    }
  }
  .lesson-title {
    justify-content: space-between;
  }
  .lesson-in-config-preview {
    .lesson-in-config-preview-list {
      margin-top: 20px;
    }
    .player-wrap {
      height: calc(100% - 44px);
      overflow-y: scroll;
      overflow-x: hidden;
      padding-right: 20px;
      &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        width: 6px;
        height: 6px;
        opacity: 0.8;
        border-radius: 3px;
        background: #c7c7c7;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-button {
        background: transparent;
      }
      &::-webkit-scrollbar-corner {
        background: transparent;
      }
    }
    .title {
      display: flex;
      justify-content: space-between;
      padding-right: 26px;
      .layout-btn {
        float: right;
        display: flex;
        align-items: center;
        .layout-icon {
          font-size: 12px;
          fill: #3262fd;
          margin-right: 4px;
        }
      }
    }
  }
}
</style>